module.exports = __webpack_public_path__ + "static/media/bip-banner-placeholder.115aac79.svg";